import React from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { IUserOrganizationImt } from 'common/interfaces/clients';
import { PermissionLevels } from 'common/constants/permissions';
import { useSocketsHandler } from './hooks/useSocketsHandler';
import { useTopics } from './hooks/useTopics';
import {
  selectIsUserLoggedIn,
  selectUserSelectedOrganization,
} from 'modules/authentication/state/selectors';
import SocketListener from 'common/components/SocketListener/SocketListener';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';

const SocketsHandler = (): JSX.Element => {
  const selectedOrg: IUserOrganizationImt = useRootSelector(selectUserSelectedOrganization);
  // We need this selector, to just re-render this component, when sign in result changed.
  useRootSelector(selectIsUserLoggedIn);
  useRootSelector(selectIsMemberPortalUserLoggedIn);

  const clubId =
    selectedOrg?.get('permissionsLevel') === PermissionLevels.CLIENT ? selectedOrg.get('id') : null;

  const onMessageHandler = useSocketsHandler(clubId || '');
  const topics = useTopics();

  return <SocketListener topics={topics} onMessage={onMessageHandler} />;
};

export default SocketsHandler;
